import { ContentContainer } from "./DayRow/StyledElements";
import IndividualWeekSettings from "./IndividualWeekSettings";
import RegularWeek from "./RegularWeek";
import { useSelector } from "../../../store/store";
import { isOddWeekUsed } from "../../../store/data";

interface Props {
    isRegular: boolean;
}

const Content = ({ isRegular }: Props) => {
    const oddWeekUsed = useSelector(isOddWeekUsed);

    return (
        <ContentContainer>
            {isRegular ? (
                <>
                    <RegularWeek weekType="even" />
                    {oddWeekUsed && isRegular && <RegularWeek weekType="odd" />}
                </>
            ) : (
                <IndividualWeekSettings />
            )}
        </ContentContainer>
    );
};

export default Content;
